module.exports = __webpack_public_path__ + "img/631.d4a84c1f.png";